import React from 'react';
import { Palette, MousePointer2, Sparkles, Monitor, Brush, CheckCircle2 } from 'lucide-react';
import './WebsiteDevelopment.css';
import Hero from '../../components/Hero/Hero';
import FAQ from '../../components/FAQ/FAQ';
import CTASection from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';

export default function WebsiteBeautification() {
  const features = [
    {
      icon: <Palette size={24} />,
      title: 'UI Modernization',
      text: 'Refreshing outdated layouts with clean typography and modern aesthetic principles.'
    },
    {
      icon: <MousePointer2 size={24} />,
      title: 'UX Refinement',
      text: 'Improving navigation and user flows to increase conversion rates and engagement.'
    },
    {
      icon: <Sparkles size={24} />,
      title: 'Custom Animations',
      text: 'Adding subtle, high-quality motion that brings your brand story to life.'
    }
  ];

  const faqItems = [
    {
      question: 'Do you redesign existing websites?',
      answer: 'Yes. We can perform everything from a light visual refresh to a complete ground-up UI/UX overhaul.'
    },
    {
      question: 'Will this affect my existing content?',
      answer: 'No. We focus on the presentation layer, ensuring your data and SEO history remains intact while the appearance is modernized.'
    }
  ];

  return (
    <article className="website-page">
      <Hero 
        eyebrow="Website Beautification"
        title={<>Elevate Your <span className="hero-accent">Brand</span> Aesthetics.</>}
        description="Transform your current website into a premium, world-class digital experience. Modern design that captures attention and builds trust."
        primaryAction={{ label: "See Transformation", link: "#impact" }}
        stats={[
          { label: "Engagement", value: "+45% increase" },
          { label: "Trust Score", value: "Verified Premium" }
        ]}
      />

      <section className="section" id="impact">
        <div className="section-heading">
          <span className="eyebrow">Design Impact</span>
          <h2>First impressions are everything.</h2>
          <p>We blend art and science to create interfaces that are not only beautiful but also results-driven.</p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="info-row">
          <div className="info-copy">
            <h3>Visual Excellence</h3>
            <p>Every pixel is intentional. We create unified design systems that communicate your brand values through color and space.</p>
            <ul className="check-list">
              <li><CheckCircle2 size={18} /> Retina-ready graphics</li>
              <li><CheckCircle2 size={18} /> Professional color theory</li>
              <li><CheckCircle2 size={18} /> High-end micro-interactions</li>
            </ul>
          </div>
          <div className="info-media">
            <img src="/images/website-beautification/design.jpg" alt="Design" />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <span className="eyebrow">Deep Dive</span>
          <h2>Design Philosophy.</h2>
        </div>
        <FAQ items={faqItems} />
      </section>

      <CTASection title="Give your site the upgrade it deserves." />
      <Footer />
    </article>
  );
}
